// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__R+OF-","switchOn":"Switch_switchOn__THHhR","switchHandle":"Switch_switchHandle__SjUbZ","switchHandleOn":"Switch_switchHandleOn__kYTGG"};